import { useMemo } from 'react';
import { useTheme } from '../../../../hooks/useTheme';
import { SelectField } from '../SelectField';
import data3dprint from '../../../../config/data3dprint.json';

interface ColorFieldProps {
  value: number | undefined;
  onChange: (value: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  isActive?: boolean;
  isNext?: boolean;
  disabled?: boolean;
  selectedTechnology: string;
  selectedPrinter: number | undefined;
  selectedMaterial: number | undefined;
}

export function ColorField({
  value,
  onChange,
  onFocus,
  onBlur,
  isActive = false,
  isNext = false,
  disabled = false,
  selectedTechnology,
  selectedPrinter,
  selectedMaterial
}: ColorFieldProps) {
  const theme = useTheme(state => state.getThemeStyles());

  const options = useMemo(() => {
    const technology = data3dprint.technologies.find(
      tech => tech.name === selectedTechnology
    );
    
    const printer = technology?.printers.find(
      p => p.id === selectedPrinter
    );

    const material = printer?.materials.find(
      m => m.id === selectedMaterial
    );

    if (!technology || !printer || !material) return [];

    return material.variants[0].colors.map(color => ({
      id: color.id,
      name: color.name,
      label: color.name
    }));
  }, [selectedTechnology, selectedPrinter, selectedMaterial]);

  const isDisabled = disabled || 
    !selectedTechnology || 
    !selectedPrinter || 
    !selectedMaterial;

  return (
    <div className={theme.components.input.variants.select.group}>
      <label 
        htmlFor="color"
        className={`
          ${theme.components.input.variants.select.label.base}
          ${isDisabled ? theme.components.input.variants.select.label.disabled : ''}
        `}
      >
        Cor
      </label>
      <SelectField
        name="color"
        label="Cor"
        options={options}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        isActive={isActive}
        disabled={isDisabled}
      />
    </div>
  );
} 